<style>
    .mdc-snackbar{
        text-align: center;
        bottom: 25px;
    }
</style>

<div class="mdc-snackbar">
    <div class="mdc-snackbar__surface confirm-center ">
        <div id="snackbar-component" class="mdc-snackbar__label check-display"
             data-cy="snackbar"
             role="status"
             aria-live="polite">
        </div>
        <div id='snackbar-action' class="mdc-snackbar__actions hidden">
            <button type="button" class="mdc-button mdc-snackbar__action">OK</button>
        </div>
    </div>
</div>
